import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Snippet from "./install-js-snippet.mdx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3 {...{
      "id": "option-1-add-the-javascript-snippet-to-your-html-span-classbg-gray-accent-light-darkbg-gray-accent-dark-text-gray-font-semibold-align-middle-text-sm-p-1-roundedrecommendedspan"
    }}>{`Option 1: Add the JavaScript snippet to your HTML `}<span className="bg-gray-accent-light dark:bg-gray-accent-dark text-gray font-semibold align-middle text-sm p-1 rounded">{`Recommended`}</span></h3>
    <Snippet mdxType="Snippet" />
    <h3 {...{
      "id": "option-2-install-via-package-manager"
    }}>{`Option 2: Install via package manager`}</h3>
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-bash",
          "metastring": "file=Yarn",
          "file": "Yarn"
        }}>{`yarn add posthog-js
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-bash",
          "metastring": "file=NPM",
          "file": "NPM"
        }}>{`npm install --save posthog-js
`}</code></pre>
    </MultiLanguage>
    <p>{`And then include it in your files:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`import posthog from 'posthog-js'
posthog.init('<ph_project_api_key>', { api_host: '<ph_client_api_host>' })
`}</code></pre>
    <p>{`If you don't want to send test data while you're developing, you can do the following:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`if (!window.location.host.includes('127.0.0.1') && !window.location.host.includes('localhost')) {
    posthog.init('<ph_project_api_key>', { api_host: '<ph_client_api_host>' })
}
`}</code></pre>
    <p>{`If you're using React or Next.js, checkout our `}<a parentName="p" {...{
        "href": "/docs/libraries/react"
      }}>{`React SDK`}</a>{` or `}<a parentName="p" {...{
        "href": "/docs/libraries/next-js"
      }}>{`Next.js integration`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      